import CTA from "./CTA";
import HeaderSocial from "./HeaderSocials";
import ME from "../../assets/me.jpg";
import "./Header.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Header() {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Aklil Solomon</h1>
        <h5 className="text-light">Fullstack Web Developer</h5>
        <CTA />
        <HeaderSocial />
        <div>
          <LazyLoadImage  effect="blur"className="me" src={ME} alt="me" />
        </div>
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
}

export default Header;
